<template lang="pug">
.pagination-actions
  v-container
    template(v-if="!pagination")
      v-layout(v-if="!noMore")
        v-flex
          v-btn(
            color="indigo"
            :loading="loading"
            outline
            @click="$emit('next')") {{ moreText }}
      v-layout.pa-3(
        v-else
        row
        align-center)
        v-divider
        div.px-3.secondary--text.text-weight-bold {{ noMoreText }}
        v-divider
    template(v-else)
      v-layout
        v-flex
          v-btn(v-show="page > 1"
            color="indigo"
            :loading="loading"
            outline
            @click="$emit('prev')") 上一頁
        v-flex
          v-btn(
            v-show="!lastpage || page < lastpage"
            color="indigo"
            :loading="loading"
            outline
            @click="$emit('next')") 下一頁
</template>

<script>
export default {
  name: "PaginationActions",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    noMore: {
      type: Boolean,
      default: false
    },
    moreText: {
      type: String,
      default: "顯示更多"
    },
    noMoreText: {
      type: String,
      default: "沒有更多資料囉"
    },
    pagination: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 0
    },
    lastpage: {
      type: Number,
      default: null
    }
  }
};
</script>
